import {ICentSample} from "@cent/analysis/models";

import {parseNumber} from "@translate/T";

export function stringIdToObject(
    id: string,
    separator: string = "-",
): ICentSample {
    const [measurement, position, optical] = id
        .split(separator)
        .map(parseNumber)
        .map((num) => (isNaN(num) ? 0 : num));

    return {measurement, position, optical};
}
